import { Component } from '@angular/core';

@Component({
  selector: 'mp-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
